import React from 'react';
import { DatePicker, Space } from 'antd';
import moment from 'moment/moment.js';
import { Spinner } from 'react-bootstrap';
import TableComponent from '../../../../../_metronic/table/TableComponent';
import { useState, useEffect } from 'react';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';

const dateFormat = 'YYYY-MM-DD';

const headers = [
  { label: 'Product name', key: 'product_name' },
  { label: 'Barcode', key: 'barcode' },
  { label: 'Total Sold quantity', key: 'totalSoldQty' },
  { label: 'Total Sold amount', key: 'totalSoldAmount' },
  { label: 'Total Vat', key: 'totalVat' },
  { label: 'Total Discount', key: 'totalDiscount' },
];

export default function ProductSalesReportTotal() {
  // Token From State
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);
  // Token From State

  const [loading, setLoading] = useState(false);
  const [saleReportList, setSaleReportList] = useState([]);
  const [saleReportTable, setSaleReportTable] = useState(false);

  const [date_from, setDate_from] = useState(
    moment()
      .startOf('month')
      .format(dateFormat)
  );
  const [date_to, setDate_to] = useState(
    moment()
      .endOf('month')
      .format(dateFormat)
  );

  // useEffect(() => {
  //   handleSearch();
  // }, []);

  // 1- Get Product Sales data by search
  const handleSearch = async () => {
    if ((date_from === undefined) & (date_to === undefined)) {
      var searchData = {};
    } else {
      searchData = {
        start_date: moment(date_from).format(dateFormat),
        end_date: moment(date_to).format(dateFormat),
      };
    }

    setLoading(true);
    const { data, status } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/productSalesReportTotal`,
      searchData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (status === 404 || status === 204 || data.data.length === 0) {
      setLoading(false);
      swal({
        title: 'No data Found',
        icon: 'info',
      });
    } else if (!data.error) {
      setLoading(false);
      if (data.data.length) {
        setSaleReportList(data.data);
        setSaleReportTable(true);
      } else {
        setSaleReportList([]);
      }
    } else {
      swal({
        title: data.message,
        icon: 'info',
      });
    }
  };
  // 1- Get Product Sales data by search

  // React Table
  const data = React.useMemo(() => saleReportList, [saleReportList]);

  const columns = React.useMemo(() => [
    {
      Header: '#',
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: 'Product name',
      accessor: 'product_name',
      paddingLeft: '0px',
    },

    {
      Header: 'Barcode',
      accessor: 'barcode',
      paddingLeft: '0px',
    },

    {
      Header: 'Total Sold quantity',
      accessor: 'totalSoldQty',
      paddingLeft: '0px',
    },
    {
      Header: 'Total Sold amount',
      accessor: (data) => Math.round(data.totalSoldAmount).toLocaleString(),
      paddingLeft: '0px',
    },
    {
      Header: 'Total Vat',
      accessor: (data) => Math.round(data.totalVat).toLocaleString(),
      paddingLeft: '0px',
    },
    {
      Header: 'Total Discount',
      accessor: (data) => Math.round(data.totalDiscount).toLocaleString(),
      paddingLeft: '0px',
    },
  ]);

  // Content
  return (
    <div className="card">
      <div className="card-header border-0 d-flex justify-content-between pb-0">
        <h3 className="card-title mb-0">Product Sales Report (Total)</h3>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-md-4">
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label>
                {' '}
                Start Date<span className="text-danger">*</span>
              </label>
              <Space direction="vertical" size={12}>
                <DatePicker
                  style={{ width: '100%', marginRight: '10px' }}
                  format={dateFormat}
                  placeholder="MM/DD/YYYY"
                  defaultValue={moment(date_from)}
                  onChange={(date, dateString) => setDate_from(dateString)}
                />
              </Space>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label>
                {' '}
                End Date<span className="text-danger">*</span>
              </label>
              <Space direction="vertical" size={12}>
                <DatePicker
                  style={{ width: '100%', marginRight: '10px' }}
                  format={dateFormat}
                  placeholder="MM/DD/YYYY"
                  defaultValue={moment(date_to)}
                  onChange={(date, dateString) => setDate_to(dateString)}
                />
              </Space>
            </div>
          </div>

          <div className="col-md-2 text-right mt-10">
            <button
              className="btn btn-primary w-75"
              onClick={handleSearch}
              // onClick={() => handleSearch()}
              disabled={loading}
            >
              Search{' '}
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </div>
        </div>
      </div>
      {saleReportTable && (
        <TableComponent
          columns={columns}
          data={data}
          hideAddButton={true}
          lists={saleReportList}
          csv={true}
          excelHeader={headers}
          filename={'Product Sales Report.csv'}
        />
      )}
    </div>
  );
}
